export default __webpack_public_path__ + "873fc7d7f7fe128512db395d0268a9b5.svg";